// src/components/Common/SystemBootLoader.tsx
import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface SystemBootLoaderProps {
  message?: string;
  isOpen?: boolean;
}

const SystemBootLoader: React.FC<SystemBootLoaderProps> = ({ 
  message = "Inicializando Neural Engine...", 
  isOpen = true 
}) => {
  
  if (!isOpen) return null;

  return (
    <Box
      sx={{ 
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        // CAMBIO CLAVE: 80vh asegura que ocupe el 80% de la pantalla.
        // Sumado al Header, esto obliga al Footer a irse al fondo.
        minHeight: '80vh', 
        gap: 3,
        bgcolor: 'transparent' 
      }}
    >
      <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        {/* Halo exterior sutil */}
        <CircularProgress 
            size={80} 
            thickness={1} 
            sx={{ 
                color: 'rgba(56, 189, 248, 0.1)', 
                position: 'absolute'
            }} 
        />
        {/* Anillo de carga activo */}
        <CircularProgress 
            size={80} 
            thickness={2} 
            sx={{ 
                color: '#38bdf8', 
                animationDuration: '1.5s'
            }} 
        />
        {/* Núcleo "Inteligente" */}
        <AutoAwesomeIcon sx={{ 
            position: 'absolute', 
            fontSize: 30, 
            color: '#fcd34d', 
            animation: 'pulse 2s infinite ease-in-out',
            '@keyframes pulse': {
                '0%': { opacity: 0.5, transform: 'scale(0.8)' },
                '50%': { opacity: 1, transform: 'scale(1.2)' },
                '100%': { opacity: 0.5, transform: 'scale(0.8)' },
            }
        }} />
      </Box>

      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" sx={{ color: '#f8fafc', fontWeight: 600, letterSpacing: 1 }}>
            PROAPricing OS
        </Typography>
        <Typography variant="caption" sx={{ color: '#64748b', fontFamily: 'monospace', mt: 1, display: 'block' }}>
            {message}
        </Typography>
      </Box>
    </Box>
  );
};

export default SystemBootLoader;